export default import.meta.ROLLDOWN_FILE_URL_tgFyw$X211zXSctfMU9_LA